import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=2f9372bd&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=2f9372bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9372bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f9372bd')) {
      api.createRecord('2f9372bd', component.options)
    } else {
      api.reload('2f9372bd', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=2f9372bd&scoped=true&", function () {
      api.rerender('2f9372bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Loader.vue"
export default component.exports